import { useTranslations } from "@/features/translations/components/translations.tsx";

export default function NoFilterOptions() {
    const t = useTranslations();

    return (
        <div className="collapse filters--no-filter-options">
            <div className="collapse__trigger">{t("no_filter_options_title")}</div>
            <div className="collapse__content">{t("no_filter_options")}</div>
        </div>
    );
}
